import { Outlet } from 'react-router-dom'
import Navbar from '@/components/feature/Navbar'
import Footer from '@/components/feature/Footer'
import ScrollToTop from '@/components/feature/ScrollToTop'

export default function Layout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <ScrollToTop />
    </>
  )
}